<template>
	<div>
		<!-- 免责声明 -->
		<div class="mobileAgree">
			<div class="text_content">
				<h3>免责声明</h3>
				<div class="mobile-agree-content">
					<p v-for="(item,i) in formattedContent('disclaimerContent')" :key="i">
						{{item}}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "disclaimer",
		data() {
			return {
				disclaimerContent:''
		
			}
		},
		mounted() {
			this.getTxtFile('免责声明', 'disclaimerContent')
		
		},
		methods: {
			formattedContent(keysName) {
				return this[keysName]
					.split(/\r?\n/)
					.filter((segment) => segment.trim());
			},
			async getTxtFile(fileName, keysName) {
				try {
					const response = await fetch("/txt/" + fileName + ".txt");
					const text = await response.text();
		
					// 判断是否有内容
					if (text && text.trim()) {
						this[keysName] = text;
						console.log("文件有内容:");
					} else {
						this[keysName] = "";
						console.log("文件内容为空");
					}
		
				} catch (error) {
					console.error("读取文件失败:", error);
				}
			}
		}
	}
</script>
<style scoped>

</style>